import { MAX_TEXTFIELD_LENGTH } from '../constants/constant';
import { Validation } from '../types/types';
import { GetTextboxValidation, NonRequired, Required } from './ValidationTypes';

export const getTextFieldValidationByDatei = (datei: any): Validation[] => {
	if (datei) {
		return [{ validateFunction: Required }, { validateFunction: GetTextboxValidation(MAX_TEXTFIELD_LENGTH) }];
	}
	return [{ validateFunction: NonRequired }];
};
